import { render, staticRenderFns } from "./NormalSearchNav521.vue?vue&type=template&id=b891820c&scoped=true"
import script from "./NormalSearchNav521.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav521.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b891820c",
  null
  
)

export default component.exports